import React from 'react'
import PropTypes from 'prop-types'

import SelectableItem from 'components/SelectableItemsList/SelectableItem'
import SelectableItemLabel from 'components/SelectableItemsList/SelectableItemLabel'

import { itemInventoryStates } from 'resources'

const SelectableItemsList = ({
  items,
  selectedItems,
  handleChange,
}) => {
  return (
    <div className="selectable-items-list">
      {items?.map(({ name, productSku, uuid, inventoryState }) => (
        <SelectableItem
          key={uuid}
          handleChange={() => handleChange(uuid)}
          checked={selectedItems.includes(uuid)}
          label={
            <SelectableItemLabel
              label={name ?? 'n/a'}
              subLabel={productSku ?? 'n/a'}
              status={itemInventoryStates?.get(inventoryState)}
            />
          }
        />
      ))}
    </div>
  )
}

SelectableItemsList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      uuid: PropTypes.string,
    })
  ),
  handleChange: PropTypes.func,
  handleCheckAllItems: PropTypes.func,
}

export default SelectableItemsList
